/**
 * Component Registry for Cobalt Theme
 *
 * Extends the base avenue theme registry with Cobalt specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-avenue/registry';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { Header } from './components/Header';
import { AmenitiesList } from './components/AmenitiesList';
import { Footer } from './components/Footer';
import { PageBlurb } from './components/PageBlurb';
import { ContactForm } from './components/ContactForm';
import { ApplyNow } from './components/ApplyNow';
import { ResidentAccess } from './components/ResidentAccess';
import { PropertyOverview } from './components/PropertyOverview';
import { ReviewsCallout } from './components/ReviewsCallout';
import { SocialFollow } from './components/SocialFollow';
import { InteractiveMapSection } from './components/InteractiveMapSection';

/**
 * Cobalt specific component overrides.
 * These components have been customized for the Cobalt brand.
 */
const cobaltOverrides: Partial<ComponentRegistry> = {
  Header,
  ScheduleTourForm,
  AmenitiesList,
  Footer,
  PageBlurb,
  ContactForm,
  ApplyNow,
  ResidentAccess,
  PropertyOverview,
  ReviewsCallout,
  SocialFollow,
  InteractiveMapSection,
};

/**
 * Final merged registry for Cobalt properties.
 * Inherits all components from the avenue theme, with Cobalt overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...cobaltOverrides,
};

export default registry;
